import { Directive, HostListener, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective implements OnInit {
  characterLimit!: number;
  @Input('appOnlyNumber') appOnlyNumber: any;

  ngOnInit(): void {
    switch (this.appOnlyNumber) {
      case 'OTP':
        this.characterLimit = 1;
        break;
      default:
        this.characterLimit = 10;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'End', 'Home',
      'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'
    ];

    // Cho phép các phím điều hướng, xóa, Enter, v.v.
    if (
      allowedKeys.includes(e.key) ||
      ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))
    ) {
      return;
    }

    const isNumber = /^[0-9]$/.test(e.key);
    const currentValue = (e.target as HTMLInputElement).value;

    // Chặn ký tự nếu không phải số hoặc vượt giới hạn
    if (!isNumber || currentValue.length >= this.characterLimit) {
      e.preventDefault();
    }
  }
}
